module.exports = __webpack_public_path__ + "static/media/07-kittel_schuhe_brille.9db19ccb.jpg";